import { makeActionCreator } from '../../../utilities'
import { CompleteChartConstants } from './completeChart.constants'

export const setSelectedOption = makeActionCreator(CompleteChartConstants.SET_SELECTED_OPTION, 'selectedOption')
export const setLockChart = makeActionCreator(CompleteChartConstants.SET_LOCK_CHART, 'lockChart', 'shouldUploadChart')
export const calculateBillingCMSValue = makeActionCreator(CompleteChartConstants.CALCULATE_BILLING_CMS)
export const setCMSValue = makeActionCreator(CompleteChartConstants.SET_CMS_VALUE, 'cmsSvcLevel')
export const setUser = makeActionCreator(CompleteChartConstants.SET_USER, 'user', 'signer')
export const setSignChartAs = makeActionCreator(CompleteChartConstants.SET_SIGN_CHART_AS, 'signChartAs', 'signer')
export const setPin = makeActionCreator(CompleteChartConstants.SET_PIN, 'pin', 'signer')
export const setAnswer1 = makeActionCreator(CompleteChartConstants.SET_ANSWER1, 'answer1', 'signer')
export const setAnswer2 = makeActionCreator(CompleteChartConstants.SET_ANSWER2, 'answer2', 'signer')
export const setVerifyCrew = makeActionCreator(CompleteChartConstants.SET_VERIFY_CREW, 'verified', 'signer')
export const setExtraSecurityId = makeActionCreator(
  CompleteChartConstants.SET_EXTRA_SECURITY_ID,
  'extraSecurityId',
  'signer'
)
export const setClinicalUser = makeActionCreator(CompleteChartConstants.SET_CLINICAL_USER, 'isClinicalUser', 'signer')
export const setQuestionList = makeActionCreator(CompleteChartConstants.SET_QUESTION_LIST, 'questionList', 'signer')
export const setClinicalUserList = makeActionCreator(CompleteChartConstants.SET_CLINICAL_USER_LIST, 'clinicalUserList')
export const setSecurityQuestionAnswerList = makeActionCreator(
  CompleteChartConstants.SET_SECURITY_QUESTION_ANSWER_LIST,
  'securityQuestionAnswerList'
)
export const setServicesBilling = makeActionCreator(CompleteChartConstants.SET_SERVICES_BILLING, 'servicesBilling')
export const setComplexRulesCount = makeActionCreator(
  CompleteChartConstants.SET_COMPLEX_RULES_COUNT,
  'complexRulesCount'
)
export const setCurrentSigner = makeActionCreator(CompleteChartConstants.SET_CURRENT_SIGNER, 'currentSigner')
export const saveSigner = makeActionCreator(CompleteChartConstants.SAVE_SIGNER)
export const addSigner = makeActionCreator(CompleteChartConstants.ADD_SIGNER)
export const deleteSigner = makeActionCreator(CompleteChartConstants.DELETE_SIGNER, 'signer')
export const setSignerList = makeActionCreator(CompleteChartConstants.SET_SIGNER_LIST, 'signerList')
export const resetSignerData = makeActionCreator(CompleteChartConstants.RESET_SIGNER)
export const clearSignerData = makeActionCreator(CompleteChartConstants.CLEAR_ALL_SIGNER_DATA)
